// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header_33uyJ","logo":"logo_3-jah","separator":"separator_3ngBr","search":"search_rJtRn"};